const small = [
    "Date",
    "Shift",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Last5DaysPerfPercent",
  ];
  const smallLIN = [
    "Date",
    "Shift",
    "Points",
    "Loading",
    "PerfDaily",
    "Last6WeeksPerformance",
    "PerfWeekly",
    "Last5DaysPerfPercent",
  ];
  const columnsDf = [
    "Date",
    "Shift",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Last5DaysPerfPercent",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
    "DfQty",
  ];
  const columnsStd = [
    "Date",
    "Shift",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Last5DaysPerfPercent",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
    "ScannedGrillsQty",
    "Setup",
  ];
  const columns = [
    "Date",
    "Shift",
    "Points",
    "Loading",
    "PerfDaily",
    "Last6WeeksPerformance",
    "Last5DaysPerfPercent",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
  ];
  const columnsOem = [
    "Date",
    "Shift",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Last5DaysPerfPercent",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
  ];
  const columnsLIN = [
    "Date",
    "Shift",
    "Points",
    "Loading",
    "PerfDaily",
    "Last6WeeksPerformance",
    "PerfWeekly",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
    "Loading",
    "PerfDaily",
    "PerfWeekly",
    "Hours per shift",
    "HSW",
    "Points",
    "Last5DaysPerfPercent",
  ];


  const columnsTh2 = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Morning",
    "",
    "",
    "",
    "",
    "",
    "Evening",
    "",
    "",
    "",
    "",
    "",
    "Night",
    "",
  ];
  const columnsTh1 = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Morning",
    "",
    "",
    "",
    "",
    "",
    "Evening",
    "",
    "",
    "",
    "",
    "",
    "Night",
    "",
    "",
  ];
  const columnsTh3 = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Morning",
    "",
    "",
    "",
    "",
    "",
    "Evening",
    "",
    "",
    "",
    "",
    "",
    "Night",
  ];
  const columnsTh4 = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Morning",
    "",
    "",
    "",
    "",
    "",
    "Evening",
    "",
    "",
    "",
    "",
    "",
    "Night",
    "",
  ];
  const columnsHSW = [
    "Date",
    "LAD",
    "DF",
    "STD",
    "N7",
    "PANEL",
    "LIN",
    "CUSTOM",
    "PAINTLINE",
    "LOUVERS",
    "STAMPING",
    "TECHINCAL STAFF",
    "MANAGEMENT"
  ];

  export {columns,columnsStd,columnsDf,columnsOem,columnsLIN,small,smallLIN,columnsTh3,columnsTh2,columnsTh1,columnsTh4,columnsHSW}